<template>
  <nav class="navbar navbar-dark navbar-categories flex-nowrap px-0 py-3">
    <b-btn v-if="$mq != 'sm'" variant="link" class="categories-button-prev text-white py-0">
      <i class="fa fa-chevron-left"></i>
    </b-btn>
		<swiper ref="swiper" :options="swiperOptions">
			<swiper-slide v-for="category in categories" :key="category.id" class="w-auto">
        <router-link :to="category.id < 0 ? { path: category.slug } : { name: 'books.category', params: { id: category.slug } }" class="py-3 px-3" :active-class="category.id < 0 ? '' : 'active'" :class="{ 'text-fade' : category.id <= 0 }">
          {{ category.text }}
        </router-link>
      </swiper-slide>
		</swiper>
    <b-btn v-if="$mq != 'sm'" variant="link" class="categories-button-next text-white py-0">
      <i class="fa fa-chevron-right"></i>
    </b-btn>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import Form from 'vform'

export default {
  computed: mapGetters({
    user: 'auth/user'
  }),

  data() {
    return {
      categoryQuery: new Form({
        query: {
          
        }
      }),
      
      categories: [
        /* {
          id: -4,
          parent_id: null,
          order: 0,
          slug: '/news',
          text: 'ニュース'
        },*/
        {
          id: -3,
          parent_id: null,
          order: 0,
          slug: '/press',
          text: 'プレスリリース'
        },
        {
          id: -2,
          parent_id: null,
          order: 0,
          slug: '/books',
          text: 'セミナー'
        }
      ],
      
			swiperOptions: {
        freeMode: true,
        freeModeMomentumRatio: 0.25,
        freeModeMomentumVelocityRatio: 0.25,
        slidesPerView: 'auto',
        loop: false,
        loopedSlides: 1,
        autoplay: false,
        breakpointsInverse: true,
        centerInsufficientSlides: true,
        centeredSlides: true,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        navigation: {
          nextEl: '.categories-button-next',
          prevEl: '.categories-button-prev',
        },
        breakpoints: {
          576: {
            centeredSlides: false,
            loop: false,
          }
        }
      }
    }
  },
  
  mounted() {
    this.getCategories();
  },

  methods: {
    getCategories() {
      this.categoryQuery.post('/api/book/category')
        .then(({ data }) => {
          this.addCategories(data)
          this.categories.splice(Math.round(this.categories.length * 0.5), 0, {
            id: -1,
            parent_id: null,
            order: 0,
            slug: '/',
            text: 'トップ'
          })
          if ( this.user ) {
            this.categories.splice(Math.round(this.categories.length * 0.5), 0, {
              id: 0,
              parent_id: null,
              order: 0,
              slug: 'bookmarks',
              text: 'マイブックマーク'
            })
          }
        });
    },

    addCategories(categories) {
      if ( categories && categories.length > 0 ) {
        categories.forEach( category => {
          this.categories.push(category)
          this.addCategories(category.categories)
        }, this);
      }
    }
  },

  watch: {
    'user': function(val) {
      this.categories = [
        /* {
          id: -4,
          parent_id: null,
          order: 0,
          slug: '/news',
          text: 'ニュース'
        }, */
        {
          id: -3,
          parent_id: null,
          order: 0,
          slug: '/press',
          text: 'プレスリリース'
        },
        {
          id: -2,
          parent_id: null,
          order: 0,
          slug: '/books',
          text: 'セミナー'
        }
      ]
      this.getCategories()
    },
    'categories': async function(val) {
      this.$refs.swiper.update()
      await this.$router.app.$nextTick()
      if ( this.$mq == 'sm' ) {
        this.$refs.swiper.swiper.slideTo(Math.round(this.categories.length * 0.5) - 1, false, false);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Categories.vue